module.exports = __webpack_public_path__ + "img/SJYG_common.908c8754.png";